import clientAxios from '../clients/clientAxios';
import { BILLS_HISTORY, BILLS_STATS, BILLS_GRAPHIC, DEFAULT_PAGE_SIZE, MP_PREFERENCE_LINKS } from '../config/apiRoutes';

export const getMpPreferenceLinks = async (page = 1, pageSize = DEFAULT_PAGE_SIZE) => {
  const { data } = await clientAxios.get(MP_PREFERENCE_LINKS, {
    params: { page, limit: pageSize },
  });
  return data;
};

export const getIncomeHistory = async ({ since, to, payment }) => {
  const { data } = await clientAxios.get(BILLS_HISTORY, {
    params: { since, to, payment },
  });
  return data;
};

export const getIncomeStats = async ({ since, to, payment }) => {
  const { data } = await clientAxios.get(BILLS_STATS, {
    params: { since, to, payment },
  });
  return data;
};

export const getIncomeGraphic = async ({ since, to, payment, year, display }) => {
  const { data } = await clientAxios.post(BILLS_GRAPHIC, { since, to, payment, year, display });
  return data;
};
